const Icon = ({ icon, className }) => (
  <span className={`icon ${className || ""}`}>{icon}</span>
);

export default Icon;
